import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {UserProvider} from "../../providers/user";
import {TeamappProvider} from "../../providers/teamapp";
import {ChatSinglePage} from "../chat-single/chat-single";

/**
 * Generated class for the ChatNewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-chat-new',
  templateUrl: 'chat-new.html',
})
export class ChatNewPage {
  members: any = [];
  searchUser: string = '';

  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider) {

  }

  ionViewDidEnter() {
    this.loadMembers();
  }

  ionViewWillLeave() {

  }

  viewUser(user: any) {

  }


  newChat(member: any) {
    this.navCtrl.push(ChatSinglePage, {
      params: {
        name: member.name,
        firstname: member.firstname,
        image: member.image,
        target: member.token,
        messages: []
      }
    })
    console.log(member);
  }

  loadMembers() {
    this.teamappProvider.http_request('action=get_chat_members', 'chat', false, true).then(data => {
     this.members = data;
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChatNewPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/chat-new/chat-new.ts